import { useQuery } from '@tanstack/react-query';
import { listVocabWords } from './api';

export const VOCAB_QUERY_KEY = ['vocabulary', 'words'] as const;

/** Words are saved from the exam runner, outside this cache: always refetch when the list opens. */
export function useVocabulary() {
  return useQuery({ queryKey: VOCAB_QUERY_KEY, queryFn: listVocabWords, staleTime: 0, refetchOnMount: 'always' });
}
